import React from 'react';
import Image from '../../../components/AppImage';

const CertificationsSection = ({ language }) => {
  const content = {
    en: {
      title: "Certifications & Partnerships",
      subtitle: "Recognized excellence in coffee trading and quality assurance",
      certifications: [
      {
        name: "ISO 9001:2015",
        image: "https://img.rocket.new/generatedImages/rocket_gen_img_13bf16e94-1764533605060.png",
        imageAlt: "ISO 9001 quality management certification badge with blue and white colors on professional certificate background"
      },
      {
        name: "Fair Trade Certified",
        image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a9d87c5b-1764533602383.png",
        imageAlt: "Fair Trade certification logo with green and black colors representing ethical trading practices"
      },
      {
        name: "Organic Certification",
        image: "https://img.rocket.new/generatedImages/rocket_gen_img_14c076fe8-1764533605355.png",
        imageAlt: "Organic certification seal with green leaf symbol on white background representing natural products"
      },
      {
        name: "SCA Member",
        image: "https://img.rocket.new/generatedImages/rocket_gen_img_1da8c5675-1764533605054.png",
        imageAlt: "Specialty Coffee Association membership badge with brown and gold colors on professional certificate"
      }]

    },
    zh: {
      title: "认证与合作伙伴",
      subtitle: "咖啡贸易和质量保证方面的卓越认可",
      certifications: [
      {
        name: "ISO 9001:2015",
        image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc0dc733-1764533605660.png",
        imageAlt: "ISO 9001质量管理认证徽章，蓝白色调在专业证书背景上"
      },
      {
        name: "公平贸易认证",
        image: "https://img.rocket.new/generatedImages/rocket_gen_img_192fa1de5-1764533603664.png",
        imageAlt: "公平贸易认证标志，绿色和黑色代表道德贸易实践"
      },
      {
        name: "有机认证",
        image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c4cfd185-1764533602572.png",
        imageAlt: "有机认证印章，白色背景上的绿色叶子符号代表天然产品"
      },
      {
        name: "SCA会员",
        image: "https://img.rocket.new/generatedImages/rocket_gen_img_10d1031b2-1764533605997.png",
        imageAlt: "精品咖啡协会会员徽章，专业证书上的棕色和金色"
      }]

    }
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 px-4 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground mb-4">
            {content?.[language]?.title}
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            {content?.[language]?.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {content?.[language]?.certifications?.map((cert, index) =>
          <div
            key={index}
            className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-smooth">

              <div className="relative h-32 mb-4 overflow-hidden rounded-md">
                <Image
                src={cert?.image}
                alt={cert?.imageAlt}
                className="w-full h-full object-contain" />

              </div>
              <h3 className="text-center text-sm md:text-base font-heading font-semibold text-foreground">
                {cert?.name}
              </h3>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default CertificationsSection;